import { Component, Fragment } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { PhoneSVG } from '../../../../../../svgComponents/phoneSVG';
import messages from './CallSupportModal.messages';
import { SupportModal } from '../../supportModal';
import { PhoneNumberButton } from './phoneNumberButton';

class CallSupportModal extends Component {
    renderTitle() {
        return <FormattedMessage {...messages.title} />;
    }

    renderCaption() {
        return <FormattedMessage {...messages.caption} />;
    }

    renderButton() {
        const { intl } = this.props;
        return (
            <PhoneNumberButton
                displayPhoneNumber={
                    <FormattedMessage {...messages.displayPhoneNumber} />
                }
                callPhoneNumber={intl.formatMessage(messages.callPhoneNumber)}
            />
        );
    }

    renderAvailabilityMessage() {
        return (
            <>
                <FormattedMessage {...messages.availabilityMessageLineOne} />
                <br />
                <FormattedMessage {...messages.availabilityMessageLineTwo} />
            </>
        );
    }

    render() {
        const title = this.renderTitle();
        const caption = this.renderCaption();
        const button = this.renderButton();
        const availabilityMessage = this.renderAvailabilityMessage();

        return (
            <SupportModal
                iconComponent={PhoneSVG}
                title={title}
                caption={caption}
                button={button}
                availabilityMessage={availabilityMessage}
            />
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(CallSupportModal);
